import useAvailableFunds from '@/features/account/hooks/use-available-funds';
import useSymbol from '@/hooks/use-symbol';
import { useAccountStore } from '@/store/use-account-store';
import { COLLATERAL_DECIMALS } from '@/store/use-markets-store';
import { CapitalStatus } from '@/types';
import { formatBigInt } from '@/utils/value-format';

export default function AvailableFunds() {
  const symbol = useSymbol();

  const availableFunds = useAvailableFunds(symbol, {
    leverage: 1,
  });

  const capitalStatus = useAccountStore((state) =>
    state.getCapitalStatus(state.address),
  );

  const isFundedOrEval = (() => {
    switch (capitalStatus) {
      case CapitalStatus.UNKNOWN:
      case CapitalStatus.NOT_ELIGIBLE:
        return false;
      default:
        return true;
    }
  })();

  if (
    isFundedOrEval &&
    capitalStatus !== CapitalStatus.ACTIVE &&
    capitalStatus !== CapitalStatus.FUNDED
  )
    return '0.00';

  return formatBigInt(availableFunds, COLLATERAL_DECIMALS, {
    digits: 2,
  });
}
